var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptySearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 144,
    viewBox: "0 0 223 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.514 128.024L199.906 142.736",
    stroke: "#B7B1AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.74 97.2524L198.982 92.0283",
    stroke: "#B7B1AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.74 46.7471L199.435 51.8532",
    stroke: "#B7B1AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.906 1.26367L182.522 15.1665",
    stroke: "#B7B1AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8659 13.8858L23.0945 1.26367",
    stroke: "#B7B1AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0789 51.2971L1.2597 46.7471",
    stroke: "#B7B1AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2597 97.2527L21.5324 92.6016",
    stroke: "#B7B1AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0945 142.737L39.8736 129.306",
    stroke: "#B7B1AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.848 81.6984C131.613 69.329 131.949 48.9382 119.638 36.1307C107.309 23.3232 86.9863 22.9862 74.2214 35.3386C61.4564 47.6911 61.1205 68.0988 73.4319 80.9063C82.8041 90.6299 96.7951 93.1746 108.569 88.4055",
    stroke: "#B7B1AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.817 85.0006C129.396 74.8557 133.024 54.7851 122.913 40.1575C112.802 25.53 92.8145 21.9069 78.2356 32.0349C63.6567 42.1629 60.0288 62.2505 70.1399 76.878C77.8157 88.0003 91.2189 92.7694 103.614 89.9551",
    stroke: "#B7B1AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8428 69.126C75.9345 71.3504 77.379 73.4569 79.1761 75.3275",
    stroke: "#B7B1AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.764 41.1182C73.2976 47.3871 71.0805 56.4029 73.1632 64.5592",
    stroke: "#B7B1AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M139.507 90.8316H134.804L126.675 82.7427C130.941 77.4006 133.881 70.8115 134.855 63.3461C137.156 45.6852 127.347 29.0692 110.82 22.5475C89.0186 13.9361 65.2355 26.356 59.2897 48.3984C54.5869 65.7896 62.481 83.619 77.379 92.1629",
    stroke: "#B7B1AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.432 95.9038C98.777 99.2573 111.34 96.2071 120.629 88.7754L128.741 96.9149V101.633L152.087 125.058C155.06 128.04 159.881 128.04 162.854 125.058C165.827 122.075 165.827 117.238 162.854 114.256L139.507 90.8313",
    stroke: "#B7B1AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/empty-search.562360e7e4635b28da198f13e3ce4bfe.svg";
export { ForwardRef as ReactComponent };